import { AnimatePresence, motion } from "framer-motion";
import {
  LucidePhoneCall,
  Mail,
  MailIcon,
  PhoneCall,
  User2,
  WebhookIcon,
  WholeWordIcon,
} from "lucide-react";
import { useCallback, useState } from "react";
import { FaRegEnvelope } from "react-icons/fa";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import logo from "../../assets/aitiu.png";
import { useDispatch } from "react-redux";
import { sendForm } from "../../slices/formularioSlice";
import { message } from "antd";
import { redirect, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { WebAssetOffRounded, WebOutlined } from "@mui/icons-material";
import envelope from "../../assets/logoEnvelope.png";

export default function Formulario() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);

  const dispatch = useDispatch();

  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPhoneFocused, setIsPhoneFocused] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Ahora recibiras nuestra informacion!",
    });
  };

  const errorToSend = () => {
    messageApi.open({
      type: "error",
      content: "Porfavor completa todos los campos",
    });
  };

  const errorEmail = () => {
    messageApi.open({
      type: "error",
      content: "Email invalido",
    });
  };

  const errorTelefono = () => {
    messageApi.open({
      type: "error",
      content: "Ingresa un numero valido de 10 digitos",
    });
  };

  const errorNombre = () => {
    messageApi.open({
      type: "error",
      content: "Ingresa un nombre valido",
    });
  };

  const handleCerrar = () => {
    window.location.href = "https://aitiu.com/";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nombreRegex = /^[a-zA-ZÀ-ÿ\s]+$/;
    const telefonoRegex = /^\d{12}$/; // Acepta exactamente 10 dígitos
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Extraer solo los dígitos del número de teléfono
    const telefonoLimpio = telefono.replace(/\D/g, ""); // Elimina todo lo que no sea un dígito

    if (!nombre || !telefono || !email) {
      errorToSend();
      return;
    }

    if (!nombreRegex.test(nombre)) {
      errorNombre();
      return;
    }

    if (!telefonoRegex.test(telefonoLimpio)) {
      errorTelefono();
      return;
    }

    if (!emailRegex.test(email)) {
      errorEmail();
      return;
    }

    const formatedData = {
      prospect: {
        name: nombre,
        phone: telefonoLimpio,
        email,
      },
    };
    dispatch(sendForm(formatedData));
    success();
    setTimeout(() => {
      setIsModalOpen(true);
    }, 1500);
    setError("");
    setNombre("");
    setTelefono("");
    setEmail("");
  };

  return (
    <div
      className="w-full h-screen"
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: { color: "#000" },
          fpsLimit: 120,
          particles: {
            number: { value: 400 },
            color: { value: ["#FF0000", "#FF7F00"] },
            shape: {
              type: "circle",
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              outMode: "bounce",
              random: true,
              straight: false,
            },
            size: {
              value: { min: 1, max: 3 },
            },
            opacity: {
              value: { min: 0.1, max: 0.5 },
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              onClick: { enable: true, mode: "push" },
            },
          },
        }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: -1,
        }}
      />
      <AnimatePresence>
        <motion.div className="w-full h-screen flex justify-center items-center relative font-poppina ">
          <div>
            {contextHolder}
            <h1 className="text-white sm:text-5xl text-xl sm:w-full w-[380px] m-auto sm:mt-0 mt-2 sm:mb-24 mb-16   text-center font-semibold ">
              Deseas recibir informacion o una consultoria gratis?{" "}
            </h1>
            <div className="formulario-container relative  sm:w-[500px] h-[500px] sm:border m-auto sm:mt-10 mt-5 flex flex-col justify-center items-center rounded ">
              {isModalOpen && (
                <AnimatePresence>
                  <motion.div
                    key="modal-background"
                    onClick={() => handleCerrar()}
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                  >
                    <motion.div
                      key="modal-content"
                      onClick={(e) => e.stopPropagation()}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      className="bg-transparent backdrop-blur-xl rounded-lg shadow-lg sm:p-8 p-6 font-poppins sm:h-[700px] h-[80vh] w-[500px] mx-4 border border-gray-100 text-center"
                    >
                      <div className="flex justify-center mb-4">
                        <img className="w-20" src={envelope} alt="" />
                      </div>
                      <p className="text-gray-400 text-lg mb-6 mt-4">
                        Hemos recibido tu información y nos pondremos en
                        contacto contigo muy pronto. Estamos ansiosos por
                        ayudarte con lo que necesites.
                      </p>

                      <h1 className="text-3xl text-white mt-16 font-semibold mb-4">
                        Contactanos
                      </h1>
                      <p className="text-white">
                        Santa martha 170, Col. el capullo, zapopan,jalisco
                      </p>
                      <div className="flex justify-center text-white mt-3 gap-2 mb-2">
                        <LucidePhoneCall />
                        <p>+52 33 33 197458</p>
                      </div>
                      <div className="flex justify-center mb-2 text-white gap-2 ">
                        <MailIcon />
                        <p>contacto@aitiu.com</p>
                      </div>
                      <div className="flex justify-center text-white gap-2">
                        <WebhookIcon />
                        <p>aitiu.com</p>
                      </div>

                      <button
                        className="mt-5  text-white border px-10 py-3 rounded-lg text-lg"
                        onClick={() => handleCerrar()}
                      >
                        Cerrar
                      </button>
                    </motion.div>
                  </motion.div>
                </AnimatePresence>
              )}

              <form onSubmit={handleSubmit} className="w-full  ">
                <img
                  className="w-[300px] absolute top-5 sm:right-24 right-10  m-auto"
                  src={logo}
                  alt=""
                />
                <div className="flex items-center p-1 border rounded w-[80%] m-auto mb-5 mt-32  ">
                  <User2 className="text-white mx-1" />
                  <input
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    className="bg-transparent w-[90%] border-none text-white focus:outline-none focus:ring-0 "
                    placeholder="Ingresa tu nombre"
                    type="text"
                  />
                </div>
                <div className="flex relative items-center p-1 border rounded my-6 w-[80%] m-auto mb-5  ">
                  <PhoneInput
                    country={"mx"}
                    value={telefono}
                    onChange={(phone) => setTelefono(phone)}
                    onFocus={() => setIsPhoneFocused(true)}
                    onBlur={() => setIsPhoneFocused(false)}
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                      backgroundColor: "transparent",
                      color: "white",
                      border: "none",
                      outline: "none",
                    }}
                    buttonStyle={{
                      backgroundColor: "transparent",
                      border: "none",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    inputProps={{
                      placeholder: "Ingresa tu número de teléfono",
                    }}
                  />
                  {!isPhoneFocused && !telefono && (
                    <div className="absolute left-[86px]  top-3 text-gray-400 pointer-events-none">
                      Ingresa tu número
                    </div>
                  )}
                </div>
                <div className="flex items-center border p-1 rounded shadow w-[80%] m-auto mt-6  ">
                  <FaRegEnvelope className="text-white w-7 h-5 mx-1" />
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    className="bg-transparent w-[90%] border-none text-white focus:outline-none focus:ring-0 "
                    placeholder="Ingresa correo electronico"
                    type="text"
                  />
                </div>

                <div className="flex justify-center mt-12">
                  <button
                    type="submit"
                    className="border p-2 text-lg px-32 text-white hover:bg-white hover:text-black transition-colors "
                  >
                    Enviar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
